import { render } from "./MessageSourceChip.vue?vue&type=template&id=1bb6a567&scoped=true"
import script from "./MessageSourceChip.vue?vue&type=script&lang=js"
export * from "./MessageSourceChip.vue?vue&type=script&lang=js"

import "./MessageSourceChip.vue?vue&type=style&index=0&id=1bb6a567&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb6a567"]])

export default __exports__